import React from 'react';
import Proptypes from 'prop-types';
import { ExperimentPanel } from './ExperimentPanel';

class ExperimentListPanel extends React.Component {
    render() {
        return (<div style={{ backgroundColor: '#ffffff', width: '180px' }} >
            <div style={{ paddingLeft: '8px' }} >
                <strong> {this.props.experiments.length} </strong> experiments found.
                </div>
            {this.props.experiments.map((experiment, index) =>
                <ExperimentPanel
                    backgroundColorCode={index % 2}
                    comments={experiment.comments}
                    creationDate={experiment.creationDate}
                    dataAcquisitionFilePath={experiment.dataAcquisitionFilePath}
                    dataCollectionCount={experiment.dataCollectionCount}
                    dataCollectionDoneCount={experiment.dataCollectionDoneCount}
                    experimentId={experiment.id}
                    experimentType={experiment.type}
                    isSelected={this.props.selectedExperimentId === experiment.id ? true : false}
                    macromolecules={experiment.macromolecules}
                    measurementAveragedCount={experiment.measurementAveragedCount}
                    measurementCount={experiment.measurementCount}
                    measurementDoneCount={experiment.measurementDoneCount}
                    name={experiment.name}
                    onExperimentClicked={this.props.onExperimentClicked}
                    proposalId={experiment.proposalId}
                    sessionId={experiment.sessionId}
                    sourceFilePath={experiment.sourceFilePath}
                    specimenCount={experiment.specimenCount}
                    status={experiment.status}
                ></ExperimentPanel>
            )}
        </div>)
    }
}

export default ExperimentListPanel;

ExperimentListPanel.proptypes = {
    /** Expeirment list */
    experiments: Proptypes.array.isRequired,
    /** selected experiment id */
    selectedExperimentId: Proptypes.number,
    /** Callback triggered when the user clicks on the experiment */
    onExperimentClicked: Proptypes.func,
}


// WEBPACK FOOTER //
// ./src/components/saxs/ExperimentListPanel.js